<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <img :src="require('@/assets/images/banner.png')" alt="" style="width: 80%">
        </b-link>

        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="check()"
          >
        <b-card-title class="mb-1 alert alert-success g">
          تم ارسال كود التفعيل على الواتسآب الخاص بك
        </b-card-title>

              <b-form-group
                label-for="email"
                label="كود التفعيل"
              >
                <validation-provider
                  #default="{ errors }"
                  name="كود التفعيل"
                  rules="required"
                >
                  <b-form-input
                    id="email" class="form-control-lg"
                    v-model="userEmail"
                    name="login-email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="كود التفعيل هنا..."
                    autofocus
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            <div class="alert alert-danger text-center g" id="error" v-if="error">
              {{ error }}
            </div>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
            >
              التفعيل الآن
            </b-button>
            <div class="text-center">
              <br><a href="javascript:;" @click="logout()">
                <i class="fa fa-sign-out"></i>
                تسجيل الخروج</a>
            </div>
          </b-form>

        </validation-observer>

      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BCardText, BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  created(){
    var g = this;
  },
  methods: {
    logout(){
        localStorage.removeItem("user")
        window.location = '/'
    },
    check(){
      var g = this;
      $.post(api + '/user/auth/activate', {
        id: g.id,
        code: g.userEmail
      })
      .then(function(r){
        if(r.status != 100){
          g.error = r.response
        }else{
          localStorage.setItem("user", JSON.stringify(r.response))
          window.location = '/'
        }
      })
      .fail(function(){
        g.error = "حدث خطأ عند الاتصال بالخادم"
      })
    }
  },
  data() {
    return {
    code: "",
    id: window.location.href.split("?id=")[1],
    userEmail: "",
    error: "",
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
